export function parseLocalDate(dateStr : string): Date | null {
    if (typeof dateStr !== 'string') return null;

    const parts = dateStr.split('-');
    if (parts.length !== 3) return null;

    const [year, month, day] = parts.map(Number);

    // Validate numbers
    if (
        isNaN(year) || isNaN(month) || isNaN(day) ||
        month < 1 || month > 12 ||
        day < 1 || day > 31
    ) {
        return null;
    }

    // Month is zero-based in JS Date
    return new Date(year, month - 1, day);
}
